import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator
} from 'react-native';

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import FormikInput from '../../components/form/FormikInput';
import FormikSelectList from '../../components/form/FormikSelectList';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
import OTPInputView from '@twotalltotems/react-native-otp-input'
import GenericHeader from '../../components/headers/GenericHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Currency } from '../../constants/Utils';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';
// import SmsRetriever from 'react-native-sms-retriever';

const analytics = new AnalyticsService


function AirtimeScreen() {
    const navigation = useNavigation()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [confirmBoxOpen, setConfirmBoxOpen] = React.useState(false)
    const hideConfirmModal = () => {
        setConfirmBoxOpen(false)
    }

    const formSchema = Yup.object().shape({
        mobile: Yup.string()
            .matches(/^\d{11}$/, 'Enter a valid mobile number')
            .required('Mobile number is required'),
        amount: Yup.string()
            .matches(/\d$/, 'Enter a valid amount')
            .test('match', 'Minimum of 100 units is allowed', amount => {
                return parseInt(amount) > 99
            })
            .required('Enter an amount'),
        provider: Yup.string().required('Select a provider')
    });

    const phoneOperatorPreset = [
        {
            label: <View style={{ flexDirection: 'row' }}>
                <Image
                    source={require('../../assets/images/main/provider_mtn.png')}
                    style={{
                        width: 20,
                        height: 20,
                    }}
                />
                <Text style={[
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.dark,
                    {
                        alignSelf: 'center',
                        marginLeft: 7
                    }
                ]}>MTN</Text>
            </View>,
            value: 'mtn',
        },
        {
            label: <View style={{ flexDirection: 'row' }}>
                <Image
                    source={require('../../assets/images/main/provider_glo.png')}
                    style={{
                        width: 20,
                        height: 20,
                    }}
                />
                <Text style={[
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.dark,
                    {
                        alignSelf: 'center',
                        marginLeft: 7
                    }
                ]}>Glo</Text>
            </View>,
            value: 'glo',
        },
        {
            label: <View style={{ flexDirection: 'row' }}>
                <Image
                    source={require('../../assets/images/main/provider_9mobile.png')}
                    style={{
                        width: 20,
                        height: 20,
                    }}
                />
                <Text style={[
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.dark,
                    {
                        alignSelf: 'center',
                        marginLeft: 7
                    }
                ]}>9mobile</Text>
            </View>,
            value: 'etisalat',
        },
        {
            label: <View style={{ flexDirection: 'row' }}>
                <Image
                    source={require('../../assets/images/main/provider_airtel.png')}
                    style={{
                        width: 20,
                        height: 20,
                    }}
                />
                <Text style={[
                    FontStyles.size14,
                    FontStyles.lh16,
                    FontStyles.dark,
                    {
                        alignSelf: 'center',
                        marginLeft: 7
                    }
                ]}>Airtel</Text>
            </View>,
            value: 'airtel',
        },
    ]

    const airtimePreset = [
        {
            label: formatCurrency(100),
            value: 100
        },
        {
            label: formatCurrency(200),
            value: 200
        },
        {
            label: formatCurrency(500),
            value: 500
        },
        {
            label: formatCurrency(750),
            value: 750
        },
        {
            label: formatCurrency(1000),
            value: 1000
        },
    ]

    const buyAirtime = (values, actions) => {
        const form = new FormData()
        form.append('model', 'buyer')
        form.append('mobile_from', buyer.phone)
        form.append('mobile_to', values?.mobile)
        form.append('provider', values?.provider)
        form.append('amount', parseInt(values?.amount) * 100)

        http.post('spend/eyowo_initiate_vtu', form, token)
            .then(res => {
                if (res.code === 200) {
                    // ToastAndroid.show(res?.data?.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    actions.resetForm()
                    navigation.navigate('WalletIndex')
                } else {
                    // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    // actions.setFieldError('passcode', res.message)
                    actions.setSubmitting(false)
                    console.warn(res)
                }
            })
            .catch(err => {
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                actions.setSubmitting(false)
                console.warn(err)
            })
    }

    const startRetrieving = async (fieldName, setValue) => {
        // try {
        //     const registered = await SmsRetriever.startSmsRetriever();
        //     if (registered) {
        //         console.log('registered listener')
        //         SmsRetriever.addSmsListener(event => {
        //             console.log('got a message', event);
        //             // console.log(event.message);
        //             // SmsRetriever.removeSmsListener();
        //         });
        //     } else {
        //         console.log('failed to register listener')
        //     }
        // } catch (error) {
        //     console.log(JSON.stringify(error));
        // }

        try {
            const phoneNumber = await SmsRetriever.requestPhoneNumber();
            console.log(phoneNumber)
            setValue(fieldName, phoneNumber)
            // Alert.alert(phoneNumber)
        } catch (error) {
            console.log(JSON.stringify(error));
        }
    };

    React.useEffect(() => {
        return () => { }
    }, [])

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {
                analytics.logEvent('Viewed BuyAirtime', buyer)
                analytics.googleHelpers.setCurrentScreen('ViewedBuyAirtime', 'ViewedBuyAirtime')
            }
        })
        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="Buy Airtime" />
            <ScrollView contentContainerStyle={styles.container}>
                <Formik
                    initialValues={{
                        mobile: `${buyer.phone}`,
                        amount: '',
                        provider: '',
                    }}
                    validateOnMount={true}
                    validationSchema={formSchema}
                    onSubmit={(values, actions) => buyAirtime(values, actions)}
                >
                    {({ values, setFieldValue, errors, isSubmitting, isValid, submitForm, validateForm }) => <View>
                        <GenericModal
                            modalState={confirmBoxOpen}
                            hideModal={hideConfirmModal}
                            icon={<View style={{ marginVertical: 20 }}>
                                <StyledIcon iconName="md-alert" iconColor={Colors.warningBackground} iconOnly size={50} style={{ marginTop: 40 }} />
                            </View>}
                            message={`Do you want to send ${formatCurrency(values.amount)} airtime to ${values.mobile} (${values.provider.toUpperCase()})? `}
                            buttons={[
                                {
                                    type: 'default',
                                    label: 'Yes, proceed',
                                    fluid: false,
                                    action: () => {
                                        hideConfirmModal()
                                        submitForm()
                                    }
                                },
                                {
                                    type: 'danger',
                                    label: 'Cancel',
                                    fluid: false,
                                }
                            ]}
                        />
                        <View style={styles.subHeader}>
                            <Text style={[
                                FontStyles.size14,
                                FontStyles.lh20,
                                styles.subHeaderText,
                            ]}>Buy airtime for your self or someone else</Text>
                        </View>
                        <View style={styles.formContainer}>
                            <View style={{ flexDirection: 'row' }}>
                                <View style={{ flexGrow: 1 }}>
                                    <FormikInput
                                        fieldName="mobile"
                                        label="Recipient Phone Number"
                                        placeholder="08010203040"
                                        style={{ marginTop: 16 }}
                                    />
                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        startRetrieving('mobile', setFieldValue)
                                    }}
                                    style={{ alignSelf: 'flex-end', paddingLeft: 6 }}
                                >
                                    <StyledIcon
                                        iconName="md-person-add"
                                        iconColor={Colors.tintColor}
                                        fillColor={`transparent`}
                                        size={42}
                                        square
                                    />
                                </TouchableOpacity>
                            </View>
                            <FormikInput
                                label="Select Operator"
                                preset={phoneOperatorPreset}
                                fieldName="provider"
                                presetOnly
                            />
                            <FormikInput
                                label="Select or Enter Amount"
                                preset={airtimePreset}
                                fieldName="amount"
                                placeholder="Enter an amount"
                            />
                            <StyledButton
                                label={`Buy ${isValid ? formatCurrency(values.amount) + ' ' : ' '}Airtime`}
                                color={isValid ? 'default' : 'light'}
                                size="lg"
                                style={{ marginTop: 30 }}
                                submitting={isSubmitting}
                                disabled={!isValid || isSubmitting}
                                action={() => {
                                    validateForm()
                                    if (isValid) {
                                        setConfirmBoxOpen(true)
                                    }
                                    console.log(values)
                                }}
                            />
                        </View>
                    </View>}
                </Formik>
            </ScrollView>
        </>
    )
}

export default AirtimeScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.shades._5,
    },
    subHeader: {
        padding: 16,
    },
    subHeaderText: {},
    formContainer: {
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 16,
        paddingBottom: 30,
    },
    starWrapper: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 58 },
    star: { width: 24, height: 28, marginHorizontal: 4 },
})